/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Calendar_ReplaceInputs */

const cs_settings_calendar_replace = /** @type {(inputs: Settings_Calendar_ReplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Připojení tohoto účtu nahradí druhého poskytovatele kalendáře.`)
};

const en_settings_calendar_replace = /** @type {(inputs: Settings_Calendar_ReplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connecting this account will replace the other calendar provider.`)
};

/**
* | output |
* | --- |
* | "Connecting this account will replace the other calendar provider." |
*
* @param {Settings_Calendar_ReplaceInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_calendar_replace = /** @type {((inputs?: Settings_Calendar_ReplaceInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Calendar_ReplaceInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_calendar_replace(inputs)
	return cs_settings_calendar_replace(inputs)
});